(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[120],{

/***/ 58472:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...slug]]",
      function () {
        return __webpack_require__(29337);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53513);
/* harmony import */ var aos__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(aos__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55351);
/* harmony import */ var _wazoe_elements__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22976);





var __N_SSG = true;
function Page(param) {
    let { page , header , footer , pageData , site , textPlaceholders , locale  } = param;
    var _pageData_seo, _pageData_seo1, _pageData_seo2;
    const { setLocale  } = (0,_wazoe_elements__WEBPACK_IMPORTED_MODULE_4__/* .useSite */ .W4)();
    const contentArray = [
        ...header,
        ...pageData.content,
        ...footer
    ];
    const elementComponent = (type, content)=>{
        if (type === "html") return _wazoe_elements__WEBPACK_IMPORTED_MODULE_4__/* .RenderHtmlElement */ .r5;
        if (type === "draggable") return _wazoe_elements__WEBPACK_IMPORTED_MODULE_4__/* .RenderDraggableElement */ .nV;
        return _wazoe_elements__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP[content.type];
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        aos__WEBPACK_IMPORTED_MODULE_2___default().init({
            useClassNames: true,
            initClassName: false,
            animatedClassName: "animate__animated",
            startEvent: "load",
            once: false
        });
        setLocale(locale);
    }, [
        locale,
        setLocale
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: "".concat(page.type === "repeatableItem" ? textPlaceholders["%NAME%"] : pageData.name, " | ").concat(site.name),
                description: (_pageData_seo = pageData.seo) === null || _pageData_seo === void 0 ? void 0 : _pageData_seo.seoDescription,
                additionalMetaTags: [
                    {
                        ...((_pageData_seo1 = pageData.seo) === null || _pageData_seo1 === void 0 ? void 0 : _pageData_seo1.seoKeywords) && {
                            property: "keywords",
                            content: (_pageData_seo2 = pageData.seo) === null || _pageData_seo2 === void 0 ? void 0 : _pageData_seo2.seoKeywords
                        }
                    }
                ]
            }),
            (contentArray === null || contentArray === void 0 ? void 0 : contentArray.length) === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wazoe_elements__WEBPACK_IMPORTED_MODULE_4__/* .NoContentFound */ .wx, {}),
            contentArray.map((content)=>{
                const ElementComponent = elementComponent(content.elementType, content);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ElementComponent, {
                    textPlaceholders: textPlaceholders,
                    elementProps: content.props,
                    ...{
                        forms: site.forms
                    },
                    ...content.type.includes("repeatable") && {
                        repeatables: site.repeatables
                    },
                    ...content.type.includes("navbar") && {
                        menus: site.menus,
                        pages: site.pages,
                        activePage: (pageData === null || pageData === void 0 ? void 0 : pageData.path) === "/" ? "/".concat(locale === null || locale === void 0 ? void 0 : locale.toLowerCase()) : "/".concat(locale === null || locale === void 0 ? void 0 : locale.toLowerCase()).concat(pageData === null || pageData === void 0 ? void 0 : pageData.path)
                    }
                }, content.id);
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,774,888,179], function() { return __webpack_exec__(58472); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);